import {Component, Inject, OnDestroy, OnInit, signal, WritableSignal} from '@angular/core';
import {MatCard} from "@angular/material/card";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs";
import {ProceduresService} from "../../../services/procedures/procedures.service";
import RappidService from "../../../services/jointjs/logigramme-service";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {getPdfBlob} from "../../../shared/logigramme/logigramme-helpers";
import {LogigrammeReadOnlyComponent} from "../../logigramme-read-only/logigramme-read-only.component";
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogContent} from "@angular/material/dialog";


@Component({
  selector: 'app-jointjs-page',
  templateUrl: './jointjs-page.component.html',
  standalone: true,
  imports: [
    MatCard,
    MatButton,
    MatIcon,
    MatProgressSpinner,
    LogigrammeReadOnlyComponent,
    MatDialogContent,
    MatDialogClose
  ],
  styleUrl: './jointjs-page.component.scss'
})
export class JointjsPageComponent implements OnInit, OnDestroy {

  procedureId: string | null;
  showDetails: boolean;
  showButtons: boolean;
  isPdfLoading: WritableSignal<boolean>;
  generatePdfSubscription: Subscription;

  // Join JS
  private rappid: RappidService

  constructor(
    private router: Router,
    private proceduresService: ProceduresService,
    @Inject(MAT_DIALOG_DATA) public data:  {procedureId: string, showDetails: boolean, showButtons: boolean },
  ) {
   this.procedureId = this.data.procedureId;
   this.showDetails = this.data.showDetails;
   this.showButtons = this.data.showButtons;
   this.isPdfLoading = signal(false);
  }

  ngOnInit(): void {

  }

  generatePdf() {
    if(this.procedureId) {
      // On récupère l'objet rappid qui contient tout notre logigramme (depuis le composant fils : "logigramme-read-only").

      this.isPdfLoading.set(true);
      this.generatePdfSubscription = getPdfBlob(this.procedureId, this.rappid.paperScroller, this.rappid.paper, this.proceduresService).subscribe(
        {
          next: response => {
            const responseArray = new Uint8Array(Object.values(response));
            const blobPdf = new Blob([responseArray], {type: 'application/pdf'});
            let fileURL = URL.createObjectURL(blobPdf);
            this.isPdfLoading.set(false);
            window.open(fileURL);

            // On remet les breaks pages en couleur originale.
            let initalStrokeColorHex: string = "#888888";
            this.setPageBreaksColorAttribute(this.rappid.paper.layers.children, initalStrokeColorHex);
          },
          error: error => {
            console.log(error);
            this.isPdfLoading.set(false);
          }
        }
      );
    }
  }

  goToModificationProcedureView() {
    this.router.navigate(['procedures/modifier-procedure', this.procedureId]).then();
  }

  // Methode privée qui cherche les balises "path" des breaks point pour pouvoir leur changer de couleur.
  private setPageBreaksColorAttribute(layerChildren: HTMLCollection, color: string) {
    let firstElementOfLayer = layerChildren.item(0);
    if(firstElementOfLayer && firstElementOfLayer.nodeName == "path") {
      firstElementOfLayer.setAttribute("stroke", color);
    }
  }

  ngOnDestroy(): void {
    this.generatePdfSubscription?.unsubscribe();
  }

  receiveRappidObject(rappidObjectReceived: RappidService) {
    this.rappid = rappidObjectReceived;
  }
}
